/**
 * The one frontend vocabulary for a MAPPING RULE's role — the backend enum
 * `FacetFlux.Models.Mapping.AttributeRole` (a different enum from the PIM attribute role, same
 * name, different members), in the camelCase the API speaks.
 *
 * MappingProfileDetail used to switch on PascalCase ("UniqueIdentifier"), which the wire never
 * sends: every role badge fell through to gray with a raw camelCase label, and the
 * mapped/unmapped split treated "unknown" as a real role because `"unknown" !== "Unknown"`.
 * AttributeRoleVocabularyTests reads this file from disk and fails when it drifts from the enum.
 */

/** Every member of the backend enum, in wire spelling. Order is the enum's own. */
export const MAPPING_ROLES = [
  "unknown", "uniqueIdentifier", "productGroup", "mainImage",
  "category", "brand", "name", "productType",
];

/** True when the rule carries a real role, not the default. */
export const hasMappingRole = (role) => Boolean(role) && role !== "unknown";

/** Badge colour per role; gray for anything unknown or future. */
const BADGE_COLORS = {
  uniqueIdentifier: "violet",
  productGroup: "cyan",
  mainImage: "teal",
  category: "orange",
  brand: "pink",
  name: "blue",
  productType: "grape",
};

export const mappingRoleColor = (role) => BADGE_COLORS[role] ?? "gray";

/** Translated display name; falls back to the raw value for a member newer than the labels. */
export const mappingRoleLabel = (role, t) =>
  hasMappingRole(role) ? t(`mappings.profile.roles.${role}`, role) : role;
